<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import firebase from 'firebase/app';


/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Bank Requests",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
     
      title: "Bank Requests",
      items: [
        {
          text: "Bank Requests",
          href: "/bank-requests",
        },
        {
          text: "Bank Requests",
          active: true,
        },
      ],
      modalTitle: "Bank Details",
      disableForm: false,
      bankRequests: [],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      useSlot: false,
      statusMessage: "",
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      selectedId: "",
      selectedStoreId: "",
      selectedStatus: "In Review",
      bankStatus: [
          "In Review",
          "Declined",
          "Approved"
      ],
      options: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      },
    };
  },
  methods: {
      openModel(item){
          this.selectedStatus = item.isApproved;
          this.selectedId = item.id;
          this.selectedStoreId = item.storeId;
          this.$bvModal.show("modal-1")
      },
      async handleOk(bvModalEvt){
          bvModalEvt.preventDefault()
          await firebase.firestore().collection("bankRequest").doc(this.selectedId).update({
              isApproved: this.selectedStatus,
              statusMessage: this.statusMessage
          });
          await firebase.firestore().collection("bankRequest").doc(this.selectedId).delete();
          await firebase.firestore().collection("stores").doc(this.selectedStoreId).update({
              'bankDetails.isApproved': this.selectedStatus
          })
          this.selectedStatus = "";
          this.selectedId = "";
          this.selectedStoreId = "";

          this.$nextTick(() => {
        this.$bvModal.hide("modal-1")
      })
      this.getAllBankREquests()
      },
    async getAllBankREquests(){
        // eslint-disable-next-line no-console
                        console.log("doing it");
      await firebase.firestore().collection("bankRequest").get().then((dataList)=>{
        if(dataList.size > 0){
          var itemArray = [];
          dataList.docs.forEach((singleDoc)=>{
            var data = {
              id: singleDoc.id,
              bankBranch: singleDoc.data().bankBranch ?? null,
              bankName: singleDoc.data().bankName ?? null,
              bankNumber: singleDoc.data().bankNumber ?? null,
              date: singleDoc.data().date.toDate().toLocaleDateString("en-US", this.options),
              isApproved: singleDoc.data().isApproved ?? false,
              nameOnAcct: singleDoc.data().nameOnAcct ?? null,
              personEmail: singleDoc.data().personEmail ?? null,
              personName: singleDoc.data().personName ?? null,
              storeId: singleDoc.data().storeId ?? null,
              userId: singleDoc.data().userId ?? null,
              paypalLink: singleDoc.data().paypalLink ?? null,
              preferred: singleDoc.data().preferred ?? null
            }
            itemArray.push(data);
            this.bankRequests = itemArray
          })
        }else{
          this.bankRequests = [];
        }
      })
    }
  },
  mounted() {
    this.getAllBankREquests();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
    </div>
    <b-modal
            id="modal-1"
            :okDisabled="disableForm"
            ok-title="Change Status"
            @ok="handleOk"
            :title="modalTitle"
          >
            <b-form ref="form" @submit.stop.prevent="handleOk">
              <b-form-group
                label="Status Message:"
              >
                <b-form-input
                  v-model="statusMessage"
                  required
                  placeholder="Enter message"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                  <b-form-select v-model="selectedStatus" :options="bankStatus" class="mb-3" />
              </b-form-group>
               
            </b-form>
          </b-modal>
    <div v-if="bankRequests" class="row">
      <div v-for="grid in bankRequests" :key="grid.id" class="col-xl-4 col-sm-6">
        <div class="card">
          <div style="cursor: pointer;" @click="openModel(grid)" class="card-body">
            <div class="media">
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-15">
                  <!-- <router-link class="text-dark" :to="'/setuppayouts/?id='+grid.id">
                    {{ grid.personName }}
                  </router-link> -->
                  {{ grid.personName }}  <p class="text-muted mb-4"> Email: {{ grid.personEmail }}</p>
                  <p class="text-muted mb-4"> Store: {{ grid.storeName }}</p>
                </h5>
                <div v-if="grid.preferred == 'bank'">
                  Bank Name : {{ grid.bankName }}<br />
                    Bank Branch : {{ grid.bankBranch }}<br />
                    Bank Number : {{ grid.bankNumber }}<br />
                    Name on Account : {{ grid.nameOnAcct }} <br />
                </div>
                <div v-else>
                  Paypal link : {{ grid.paypalLink }}<br />
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 border-top">
            <ul class="list-inline mb-0">
              <li class="list-inline-item me-3">
                <span
                  class="badge bg-warning"
                  >{{ grid.date }}</span
                >
              </li>
              <li class="list-inline-item me-3">
                <p class="text-muted mb-4">Bank status: {{ grid.isApproved }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
